import { render, staticRenderFns } from "./ProductionContractForm.vue?vue&type=template&id=7c678fbe&"
import script from "./ProductionContractForm.vue?vue&type=script&lang=js&"
export * from "./ProductionContractForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductionContractForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports